import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Modal,Form,Select } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,EditOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined,DownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import ReactExport from "@ibrahimrahmani/react-export-excel";


var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;

function callback(key) {
  console.log(key);
}

const dateFormat = 'DD/MM/YYYY';
const FormItem=Form.Item;

var username=''
var token= ''
var sacco= ''

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class SalaryRequistionList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    datarequested:true,
    selectedreqobject:{},
    detailmodalvisible:false,
    requistionitems:[],
    updatmodalvisible:false,
    
    salaryamount:0,
    salaryadvance:0,
    selectedadvanceitem:{},
    paymonth:'',
    nssfamount:0,
    salaryrequisition:[],
    current_selected_list:[],
    currentlismodalvisible:false


  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)

      }else{
       sacco= ''
       username=''

    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/saccos/${sacco}`)
    .then(res => {
      console.log(res.data)

        //this.setState({selectedreqobject:record})
        if(res.data.salary_list==null ){
          console.log("no data")
        }else{
          this.setState({requistionitems:JSON.parse(res.data.salary_list)})

        }
    })



    axios.get(serverconfig.backendserverurl+`/api/salaryrequisition/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          salaryrequisition:res.data
        })
        this.setState({datarequested:false})
    })

}

getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/idtypes/${id}`).then(res =>{
      window.location.reload(false)
      message.info("successfully deleted") 
     }
     );
  };


  //calculate net salary
  caltotalnetsalary=()=>{
    var total=0

    this.state.requistionitems.map((item)=>{
      total+=Number(item.netpay)
    })
    return total;
  }

  //calculate 
  caltotalsalary=()=>{
    var total=0

    this.state.requistionitems.map((item)=>{
      total+=Number(item.salaryamount)
    })
    return total;
  }

  caltotaladvance=()=>{
    var total=0
    this.state.requistionitems.map((item)=>{
      total+=Number(item.salaryadvance)
    })
    return total;
  }


  calculateTotaloflist_netpay=(my_list)=>{
    var total=0
    my_list.map((item)=>{
      total+=Number(item.netpay)
    })
    return total;
  }

  calculateTotaloflist_netadvance=(my_list)=>{
    var total=0
    my_list.map((item)=>{
      total+=Number(item.salaryadvance)
    })
    return total;
  }

  calculateTotaloflist_netnssf=(my_list)=>{
    var total=0
    my_list.map((item)=>{
      total+=Number(item.nssfamount)
    })
    return total;
  }

  calculateTotaloflist_netgrosssalary=(my_list)=>{
    var total=0
    my_list.map((item)=>{
      total+=Number(item.salaryamount)
    })
    return total;
  }


  render() {
    
    const listcolumns = [
      {
        title: 'AccountName',
        dataIndex: 'accountname',
        key: 'id',
      },
      {
        title: 'AccountNumber',
        dataIndex: 'accountnumber',
        key: 'id',
      },
      {
        title: 'Salary Amount',
        dataIndex: 'salaryamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Salary Advance',
        dataIndex: 'salaryadvance',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Nssf',
        dataIndex: 'nssfamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },

      {
        title: 'Net pay',
        dataIndex: 'netpay',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
        <Popover content={<p>Click here to edit </p>} title="">
          <EditOutlined style={{color:'blue'}}
          onClick={()=>{
            this.setState({updatmodalvisible:true})

            this.setState({selectedadvanceitem:record})
            this.setState({salaryamount:Number(record.salaryamount)})
            this.setState({salaryadvance:Number(record.salaryadvance)})
            this.setState({nssfamount:Number(record.nssfamount)})

          }}
          />
        </Popover>
        </p>,
      }
      
    ];



    const curent_listcolumns = [
      {
        title: 'AccountName',
        dataIndex: 'accountname',
        key: 'id',
      },
      {
        title: 'AccountNumber',
        dataIndex: 'accountnumber',
        key: 'id',
      },
      {
        title: 'Salary Amount',
        dataIndex: 'salaryamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Salary Advance',
        dataIndex: 'salaryadvance',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Nssf',
        dataIndex: 'nssfamount',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },

      {
        title: 'Net pay',
        dataIndex: 'netpay',
        key: 'id',
        render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
      },
     
    ];


    const new_listcolumns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'id',
      },
      {
        title: 'Salary month',
        dataIndex: 'salary_month',
        key: 'id',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'id',
      },
      {
        title: 'Total receivers',
        dataIndex: 'id',
        key: 'id',
        render:(text,record)=>
        <p>
          {JSON.parse(record.reitems).length}
        </p>
      },
      {
        title: 'Gross Salary',
        dataIndex: 'id',
        key: 'id',
        render:(text,record)=>
        <CurrencyFormat value={this.calculateTotaloflist_netgrosssalary(JSON.parse(record.reitems))} displayType={'text'} thousandSeparator={true}  />
      },
      {
        title: 'Total Advances',
        dataIndex: 'id',
        key: 'id',
        render:(text,record)=><CurrencyFormat value={this.calculateTotaloflist_netadvance(JSON.parse(record.reitems))} displayType={'text'} thousandSeparator={true} />
      },

      {
        title: 'NSSF',
        dataIndex: 'id',
        key: 'id',
        render:(text,record)=><CurrencyFormat value={this.calculateTotaloflist_netnssf(JSON.parse(record.reitems))} displayType={'text'} thousandSeparator={true} />
      },

      {
        title: 'Netpay',
        dataIndex: 'id',
        key: 'id',
        render:(text,record)=><CurrencyFormat value={this.calculateTotaloflist_netpay(JSON.parse(record.reitems))} displayType={'text'} thousandSeparator={true} />
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
        <Popover content={<p>Click here to edit,view details</p>} title="Edit,View">
        <FundViewOutlined style={{color:'blue'}} onClick={()=>{

          this.setState({current_selected_list:JSON.parse(record.reitems)})
          this.setState({currentlismodalvisible:true})

        }}/>
        </Popover>
        </p>,
        
      },


    ];


    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
          <h3>Salary receivers  list</h3>

          <Table 
          columns={listcolumns}
          pagination={{showQuickJumper:true,showSizeChanger:true }}
          dataSource={this.state.requistionitems}
          scroll={{ x: 1000 }}
          bordered/>

          <div style={{display:'flex',flexDirection:'row'}}>
          <h4>Salary: <CurrencyFormat value={this.caltotalsalary()} displayType={'text'} thousandSeparator={true}  />  | Advance: <CurrencyFormat value={this.caltotaladvance()} displayType={'text'} thousandSeparator={true}  />  |  Net Salary: <CurrencyFormat value={this.caltotalnetsalary()} displayType={'text'} thousandSeparator={true}  /></h4>

          </div>

          <h3>Make salary payment</h3>
          <FormItem label="Pay month">
          <Input name="paymonth"  placeholder="Pay month" value={this.state.paymonth} onChange={(val)=>{this.setState({paymonth:val.target.value})}} />

          </FormItem>

  
        {
          this.state.requistionitems.length>0?
          <Button  type="primary" htmlType='button'
            
          onClick={()=>{

            if (this.state.requistionitems.length<=0){
              message.error("No payment list")

            }else if(this.state.paymonth===""){
              message.error("Please enter payment month")
            }else{
              this.setState({datarequested:true})

              //get last slip number
              let form_data = new FormData();
  
              form_data.append('date', moment().format(dateFormat).toString());
              form_data.append('sacco', sacco);
              form_data.append('requistionrequests', JSON.stringify(this.state.requistionitems));
              form_data.append('paymonth', this.state.paymonth);
              form_data.append('username', username);

              axios.post(serverconfig.backendserverurl+'/customqueries/confirmsalarydeposits', form_data, {
                headers: {
                  'content-type': 'multipart/form-data'
                }
                })
              .then(res => {
                message.info("Successfully deposited money on all accounts")
  
                this.setState({datarequested:false})
                window.location.reload(false)
  
              })
              .catch(error => console.log(error))
  
            }

          }}
          
          >Confirm Salary Deposits</Button>
          :
          null
        }


        <br></br>
        <br></br>
        <h3>Previous salary payments</h3>

        <ExcelFile  element={<Button type='primary' icon={<DownloadOutlined/>}>Download payments Excel</Button>}>
          <ExcelSheet data={this.state.salaryrequisition} name="Salary payments">
              <ExcelColumn label="Date" value="date"/>
              <ExcelColumn label="Salary month" value="salary_month"/>
              <ExcelColumn label="Status" value="status"/>
          </ExcelSheet>
       </ExcelFile>
       <br></br>
       <br></br>

        <Table 
          columns={new_listcolumns}
          pagination={{showQuickJumper:true,showSizeChanger:true }}
          dataSource={this.state.salaryrequisition}
          scroll={{ x: 1000 }}
          bordered/>
         <br></br>

          <Modal    
            visible={this.state.updatmodalvisible}
            title="Requistion Update"
            onCancel={()=>{this.setState({updatmodalvisible:false})}}
            footer={[
              <Button key="back" onClick={()=>{this.setState({updatmodalvisible:false})}}>
                Cancel
              </Button>
              ]}
              >

            <FormItem label="Salary Amount"
            >
              <Input name="salaryamount"  placeholder="0.00" value={this.state.salaryamount} onChange={(val)=>{this.setState({salaryamount:val.target.value})}} />
            </FormItem>

            <FormItem label="Salary Advance"
            >
              <Input name="salaryadvance"  placeholder="0.00" value={this.state.salaryadvance} onChange={(val)=>{this.setState({salaryadvance:val.target.value})}} />
            </FormItem>


            <Button key="back" type='primary' onClick={()=>{

              const elementsIndex = this.state.requistionitems.findIndex(element => element.memberid == this.state.selectedadvanceitem.memberid)

              let newArray = [...this.state.requistionitems]
            
              newArray[elementsIndex] = {...newArray[elementsIndex], 

                'salaryamount':this.state.salaryamount,
                'salaryadvance':this.state.salaryadvance,
                'netpay':Number(this.state.salaryamount)-(Number(this.state.salaryadvance)+Number(this.state.nssfamount))
              }
            
              this.setState({
                requistionitems: newArray,
              });

              this.setState({updatmodalvisible:false})

              }}>
                  Update
            </Button>
            </Modal>



            <Modal    
            visible={this.state.currentlismodalvisible}
            title="Salary paid list"
            onCancel={()=>{this.setState({currentlismodalvisible:false})}}
            footer={[
              <Button key="back" onClick={()=>{this.setState({currentlismodalvisible:false})}}>
                Cancel
              </Button>
              ]}

              >
            <Table 
              columns={curent_listcolumns}
              pagination={{showQuickJumper:true,showSizeChanger:true }}
              dataSource={this.state.current_selected_list}
              scroll={{ x: 1000 }}
              bordered/>
            </Modal>

        </div>
        )

    }
   
  }
}

export default SalaryRequistionList; 
